<template>
  <div class="itemContainer">
    <img class="newImage" :src="item.image" />
    <div class="leftContent">
      <div class="title">{{ item.title }}</div>
      <div class="date">{{ item.subtitle1 }}</div>
      <div class="date">{{ item.date }}</div>
      <button type="button" class="detailButton" @click="goLink">
        자세히보기
        <b-icon icon="chevron-right" class="" font-scale="1" />
      </button>
    </div>
  </div>

  <!--  <b-container class="container-fluid">-->
  <!--    <b-row>-->
  <!--      <b-col align-self="start">-->
  <!--        <div class="leftContent">-->
  <!--          <div class="title">{{ item.title }}</div>-->
  <!--          <div class="date">{{ item.date }}</div>-->
  <!--        </div>-->
  <!--      </b-col>-->
  <!--      <b-col align-self="center">-->
  <!--        <img class="newImage" src="https://placekitten.com/1000/300" />-->
  <!--      </b-col>-->
  <!--    </b-row>-->
  <!--  </b-container>-->
</template>

<script>
export default {
  name: 'DiningItems',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      price: 0,
    };
  },

  mounted() {
    // console.log('D-ITEM', this.item);
    this.price = new Intl.NumberFormat('ko-KR', {style: 'currency', currency: 'KRW'}).format(this.item.price);
  },

  methods: {
    prevClick() {
      console.log('prev');
      this.$emit('prevClick');
    },
    nextClick() {
      console.log('next');
      this.$emit('nextClick');
    },
    goLink() {
      console.log('go');
      this.$router.push({name: 'NewsroomDetail', params: {id: this.item.id}});
    },
  },
};
</script>

<style scoped lang="scss">
@mixin ellipsis($line-cnt, $line-height) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $line-cnt; /* 라인수 */
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: normal;
  line-height: $line-height;
  height: ($line-height * $line-cnt); /* line-height 가 1.2em 이고 3라인을 자르기 때문에 height는 1.2em * 3 = 3.6em */
}

.navButton {
  margin-top: 10px;
  margin-right: 10px;
  background-color: white;
  color: gray;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}

.navButton:hover {
  margin-top: 10px;
  margin-right: 10px;
  background-color: lightgrey;
  color: gray;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
h5 {
  word-break: keep-all;
}

@media (max-width: 768px) {
  .itemContainer {
    height: 600px;
    border: 1px solid #ddd;
  }

  .date {
    margin-left: 10px;
    color: gray;
  }

  .btnDiv {
    display: none;
  }

  .detailButton {
    margin-top: 20px;
    margin-right: 10px;
    background-color: white;
    color: gray;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
    right: 0;
  }

  .detailButton:hover {
    margin-top: 20px;
    margin-right: 10px;
    background-color: grey;
    color: white;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
  }
  .leftContent {
    padding: 2em;
    width: 100%;
    height: auto;
    right: 3em;
  }

  .title {
    @include ellipsis(2, 1.1em);
    font-size: 1.7em;
    font-weight: 900;
    right: 3rem;
  }

  .date {
    margin-top: 20px;
    font-size: 1em;
  }

  .newImage {
    width: 100%;
    height: 60%;
    object-fit: cover;
  }
}

@media (min-width: 768px) {
  .itemContainer {
    height: 500px;
    border: 1px solid #ddd;
  }

  .date {
    margin-left: 10px;
    color: gray;
  }

  .btnDiv {
    position: absolute;
    bottom: 0;
    margin-bottom: 2em;
    z-index: 20;
  }

  .detailButton {
    margin-top: 40px;
    margin-right: 10px;
    background-color: white;
    color: gray;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
    right: 0;
  }

  .detailButton:hover {
    margin-top: 40px;
    margin-right: 10px;
    background-color: grey;
    color: white;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
  }
  .leftContent {
    padding: 2em;
    float: left;
    width: 40%;
    height: auto;
    right: 3em;
  }

  .title {
    @include ellipsis(3, 1.3em);
    font-size: 2em;
    font-weight: 900;
    right: 3rem;
  }

  .date {
    margin-top: 30px;
    font-size: 1.25em;
  }

  .newImage {
    width: 60%;
    height: 100%;
    object-fit: cover;
  }
}

@media (min-width: 992px) {
  .itemContainer {
    height: 500px;
    border: 1px solid #ddd;
  }
  .date {
    margin-left: 10px;
    color: gray;
  }

  .btnDiv {
    position: absolute;
    bottom: 0;
    margin-bottom: 2em;
    z-index: 20;
  }

  .detailButton {
    margin-top: 40px;
    margin-right: 10px;
    background-color: white;
    color: gray;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
    right: 0;
  }

  .detailButton:hover {
    margin-top: 40px;
    margin-right: 10px;
    background-color: grey;
    color: white;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
  }
  .leftContent {
    padding: 2em;
    float: left;
    width: 40%;
    height: auto;
    right: 3em;
  }

  .title {
    @include ellipsis(3, 1.3em);
    font-size: 2em;
    font-weight: 900;
    right: 3rem;
  }

  .date {
    margin-top: 30px;
    font-size: 1.25em;
  }

  .newImage {
    width: 60%;
    height: 100%;
    object-fit: cover;
  }
}

@media (min-width: 1200px) {
  .itemContainer {
    height: 500px;
    border: 1px solid #ddd;
  }

  .date {
    margin-left: 10px;
    color: gray;
  }

  .btnDiv {
    position: absolute;
    bottom: 0;
    margin-bottom: 2em;
    z-index: 20;
  }

  .detailButton {
    margin-top: 40px;
    margin-right: 10px;
    background-color: white;
    color: gray;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
    right: 0;
  }

  .detailButton:hover {
    margin-top: 40px;
    margin-right: 10px;
    background-color: grey;
    color: white;
    border: 1px solid #ddd;
    width: 130px;
    height: 50px;
  }

  .leftContent {
    padding: 2em;
    float: left;
    width: 40%;
    height: auto;
    right: 3em;
  }

  .title {
    @include ellipsis(3, 1.3em);
    font-size: 2em;
    font-weight: 900;
    right: 3rem;
  }

  .date {
    margin-top: 30px;
    font-size: 1.25em;
  }

  .newImage {
    width: 60%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
